import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const AddReview: FC<Props> = ({ width = 18, height = 19, className, color = "#2A1645" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 18 19"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.97875 17.29L9 16.7275L11.25 12.79H14.625C14.9234 12.79 15.2095 12.6715 15.4205 12.4605C15.6315 12.2496 15.75 11.9634 15.75 11.665V4.91504C15.75 4.61667 15.6315 4.33052 15.4205 4.11954C15.2095 3.90857 14.9234 3.79004 14.625 3.79004H3.375C3.07663 3.79004 2.79048 3.90857 2.5795 4.11954C2.36853 4.33052 2.25 4.61667 2.25 4.91504V11.665C2.25 11.9634 2.36853 12.2496 2.5795 12.4605C2.79048 12.6715 3.07663 12.79 3.375 12.79H8.4375V13.915H3.375C2.77826 13.915 2.20597 13.678 1.78401 13.256C1.36205 12.8341 1.125 12.2618 1.125 11.665V4.91504C1.125 4.3183 1.36205 3.74601 1.78401 3.32405C2.20597 2.90209 2.77826 2.66504 3.375 2.66504H14.625C15.2217 2.66504 15.794 2.90209 16.216 3.32405C16.6379 3.74601 16.875 4.3183 16.875 4.91504V11.665C16.875 12.2618 16.6379 12.8341 16.216 13.256C15.794 13.678 15.2217 13.915 14.625 13.915H11.9025L9.97875 17.29Z"
        fill={color}
      />
      <path
        d="M9.5625 5.47754H8.4375V7.72754H6.1875V8.85254H8.4375V11.1025H9.5625V8.85254H11.8125V7.72754H9.5625V5.47754Z"
        fill={color}
      />
    </svg>
  );
};

export default AddReview;
